import * as angular from 'angular';
import { StudentCreditGapsPanelCourseHistoryComponent } from './student-credit-gaps-panel-course-history.component';

export const StudentCreditGapsPanelCourseHistoryModule = angular
  .module('studentCreditGapsPanelCourseHistory', [])
  .component('studentCreditGapsPanelCourseHistory', StudentCreditGapsPanelCourseHistoryComponent).name;
